<template>
  <div class="grarantee-form-contanier">
    <Nav applyType="7000"></Nav>
    <Step :arr="arr" class="mb-6"></Step>
    <div>
      <component
        :is="electronicComponent"
        ref="form"
        @changeIndex="changeIndex"
      ></component>
    </div>
  </div>
</template>
<script>
import Step from '../../components/CA/Step'
import nav from '../../components/letter_nav/letter.nav'
import { queryOrderDetail,queryOrderByOuterOrderNo } from '@/api/order'
import information from '../../components/applyInsuranceStepView/information/information.vue'
import project from '../../components/applyInsuranceStepView/project/project.vue'
import confirmation from '../../components/applyInsuranceStepView/confirmation/confirmation.vue'
import { mapMutations, INSURANCE } from '@/store/modules/insurance'
import { ORDER_TYPE, checkGuaranteeDraft } from '@/shared/guaranteeDraft'
const components = [information, project, confirmation]

export default {
  components: {
    Nav: nav,
    Step,
    Information: information,
    Project: project,
    Confirmation: confirmation,
  },
  data() {
    return {
      arr: [
        { icon: 1, span: '电子保险保函信息填写', status: 'finish', time: '' },
        { icon: 2, span: '电子保险保函信息确认', status: 'wait', time: '' },
        { icon: 3, span: '支付', status: 'wait', time: '' },
        { icon: 4, span: '平台审核', status: 'wait', time: '' },
        { icon: 5, span: '平台出函', status: 'wait', time: '' },
      ],
      operationIndex: 0,
    }
  },
  methods: {
    ...mapMutations({
      insurance: INSURANCE.INSURANCE,
      clear: INSURANCE.CLEAR,
    }),
    changeIndex(index) {
      this.operationIndex = index || 0
    },
    getDataDetail(orderID) {
      return queryOrderDetail(orderID).then((v) => {
        return v.data
      })
    },
    doInit(orderID, outerOrderNo) {
      if (orderID) {
        this.getDataDetail(orderID).then((data) => {
          this.clear()
          this.insurance(data)
          this.$refs.form.init(data)
        })
      } else if (outerOrderNo) {
        queryOrderByOuterOrderNo(outerOrderNo).then((v) => {
          if (v.data) {
            this.clear()
            this.insurance(v.data.model)
            this.$refs.form.init(v.data.model)
          }
        })
      }
    },
  },
  async created() {
    const { orderID, outerOrderNo } = this.$route.query
    const isNewOrder = !orderID
    if (isNewOrder) {
      const handled = await checkGuaranteeDraft(this, ORDER_TYPE.INSURANCE_7000, {
        restore: (draft) => {
          if (draft.formData) {
            const savedStep = typeof draft.step === 'string' ? parseInt(draft.step, 10) : draft.step
            this.operationIndex = Number.isNaN(savedStep) ? 0 : savedStep
            this.clear()
            this.insurance(draft.formData)
            this.$nextTick(() => {
              if (this.$refs.form && typeof this.$refs.form.init === 'function') {
                this.$refs.form.init(draft.formData)
              }
            })
          }
        },
        skipRestore: () => {
          // 重新申请 —— 清 Redis + Vuex + 强制当前子组件清空表单
          this.clear()
          // checkGuaranteeDraft 是异步弹窗，子组件已在 created→mount 之间
          // 用旧 formStorage 初始化过 this.form 了，必须显式调 init({}) 覆盖
          this.$nextTick(() => {
            if (this.$refs.form && typeof this.$refs.form.init === 'function') {
              this.$refs.form.init({})
            }
          })
          this.doInit(orderID, outerOrderNo)
        },
      })
      // 没有缓存（checkGuaranteeDraft 返回 false），直接走正常初始化
      if (!handled) {
        this.doInit(orderID, outerOrderNo)
      }
    } else {
      this.doInit(orderID, outerOrderNo)
    }
  },
  computed: {
    index() {
      return this.operationIndex
    },
    electronicComponent() {
      return components[this.index]
    },
  },
}
</script>
<style scoped></style>
